<app-img-header
    title="Configuración del cotizador"
    alt="Daimler Truck"
    image="/assets/images/cotizador/intro.jpg"
>
</app-img-header>
